export default __webpack_public_path__ + "static/media/ILUSTRACIONES_06.d13b3f9b.png";